<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.52 13.52" class="icon">
        <title>close</title>
        <line x1="0.75" y1="0.75" x2="12.77" y2="12.77"
              style="fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px" v-bind:style="{stroke: color}"/>
        <line x1="12.77" y1="0.76" x2="0.76" y2="12.77"
              style="fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px" v-bind:style="{stroke: color}"/>
    </svg>
</template>

<script>
    export default {
        name: "IconClose",

        props: {
            color: {
                type: String,
                default: '#231f20'
            }
        }
    }
</script>
